module.exports = __webpack_public_path__ + "static/media/heart-empty.9fb67e0f.svg";